export const Images = {
    logo: require("../assets/img/logo.png"),
    ok: require("../assets/img/ok.jpg"),
    banner: require("../assets/img/banner.png"),
    noImage: require("../assets/img/no-image.png"),
    sample: require("../assets/img/sample-sub.jpg"),
    popup: require("../assets/img/popup.jpeg"),
}